import React from 'react'
import IconWithBackground from '../IconWithBackground/IconWithBackground'
import { OrderDetailResponse, OrderLine, Product } from '../../model'
import { formatDate } from '../../helpers/utils'
import { formatCurrencyValue } from '../../helpers/utils'
import ProductItem from '../ProductItem/ProductItem'

interface OrderDetailHeaderProps {
    order: OrderDetailResponse
}

const OrderDetailHeader: React.FC<OrderDetailHeaderProps> = ({ order }) => {
    const address = order.address
    const isPackage = order.products?.length > 0

    return (
        <div>
            <h2 className='text-base'>Opdracht</h2>
            <div>
                <div className='grid items-center flex-grow grid-cols-12 gap-y-2 gap-x-3 lg:gap-x-4'>
                    <div className='col-span-full sm:col-span-5  lg:col-span-4 flex items-center space-x-3'>
                        <div>
                            <div className='flex items-center space-x-3 w-full min-w-0'>
                                <IconWithBackground iconName='house' />
                                <div className='flex flex-col'>
                                    <span className='font-semibold text-sm truncate text-wrap'>
                                        {address.street} {address.houseNumber}
                                        {address.extension && ` (${address.extension})`}
                                    </span>
                                    <span className='text-xs font-medium text-[--tb-textLight]'>
                                        {address.zipcode} {address.city}
                                    </span>
                                    {order.surface && (
                                        <span className='text-xs text-[--tb-primary]'>{order.surface} m2</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-between items-center my-2 flex-wrap gap-4 mb-4 col-span-6 sm:col-span-4 md:col-span-5 lg:col-span-4'>
                        <div className='flex space-x-3 items-center'>
                            {/* @Todo: display dynamic icon here */}
                            <IconWithBackground size='small' iconName={isPackage ? 'box' : 'calendar'} />

                            <div className='flex flex-col justify-center w-full min-w-0'>
                                <span className='font-medium text-sm truncate text-wrap'>{order.title}</span>
                                {order.orderDate && (
                                    <span className='text-xs'>
                                        <strong className='mr-2 font-semibold'>Besteld:</strong>
                                        <span className='text-[--tb-textLight]'>{formatDate(order.orderDate)}</span>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Price */}
                    <div className='col-span-6 sm:col-span-2 md:col-span-2 lg:col-span-1 flex flex-col justify-start text-xs text-right md:text-left'>
                        <span className='text-[--tb-textLight]'>Totaal</span>
                        {order.totalPrice ? (
                            <span className='font-semibold'>{formatCurrencyValue(order.totalPrice)}</span>
                        ) : (
                            '-'
                        )}
                    </div>
                </div>
                {order.remarks && (
                    <div className='flex justify-start space-x-2 items-center mt-4 sm:pl-14 w-full'>
                        <IconWithBackground iconName='comment' size='extraSmall' className='mr-2' />
                        <span className='text-xs'>{order.remarks}</span>
                    </div>
                )}
            </div>
            <div className='flex w-full flex-col mt-4 border-top pt-2'>
                <h3 className='mb-1 mt-4'>Jouw producten</h3>
                {order.products?.map((product: OrderLine) => {
                    return (
                        <div key={product.id}>
                            <ProductItem product={product as Product} showOptions={false} key={product.id} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default OrderDetailHeader
